/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  manageCounterProcessing,
  metamaskErrorMessages,
  notificationPosition,
  notificationSetting,
  notificationType,
  saleType,
  showNotification,
} from "../Common";
import { loaderType, StartLoader, StopLoader } from "../Common/Loader";
import {
  getcurrentlyConnectWallet,
  mintNFT,
  privateSaleStatus,
  totalValues,
} from "../Scripts/interact";
import { MintButton } from "../SubSection/MintButton";

const Mint = () => {
  const [waiting, setWaiting] = useState(false);
  const [wallet, setWallet] = useState({
    address: null,
    balance: null,
    chainId: null,
  });
  const [walletConnected, setWalletConnected] = useState(false);
  const [mintSaleType, setMintSaleType] = useState(saleType.STANDARD);
  const [quantity, setQuantity] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [soldOut, setSoldOut] = useState(false);
  const [maxValues, setMaxValues] = useState({
    maxMints: 0,
    totalRemaining: 0,
    maxPerMint: 0,
    price: null,
  });
  const quantityRef = useRef();

  useEffect(() => {
    const getAndSetWalletData = async () => {
      const { status, address, walletBalance, chainId } =
        await getcurrentlyConnectWallet();

      if (status) {
        setWalletConnected(true);
      } else {
        setWalletConnected(false);
        setMaxValues({
          maxMints: 0,
          totalRemaining: 0,
          maxPerMint: 0,
          price: null,
        });
      }

      // getPrivateSaleStatus();

      setWallet(() => {
        return { address: address, balance: walletBalance, chainId: chainId };
      });
    };
    getAndSetWalletData().catch(console.error);
  }, [wallet.address]);

  useEffect(() => {
    const getAndSetTotalValues = async () => {
      try {
        setWaiting(true);
        let response = await totalValues();
        console.log("Response: ", response);
        if (response?.total && Object.keys(response?.total).length > 0) {
          setWaiting(false);
        }
        setTotalValues(response?.total);
      } catch (error) {
        console.log(error);
        showNotification(
          notificationType.DANGER,
          metamaskErrorMessages.browserNotSupported,
          notificationSetting
        );
        setMaxValues({
          maxMints: 100,
          totalRemaining: 0,
          maxPerMint: 3,
          price: null,
        });
      }
    };
    getAndSetTotalValues().catch(console.error);
  }, []);

  useEffect(() => {
    setTotalAmountValues(quantity);
  }, [maxValues.price]);

  useEffect(() => {
    if (
      parseInt(maxValues.maxMints) === parseInt(maxValues.totalRemaining) &&
      parseInt(maxValues.maxMints) !== 0 &&
      parseInt(maxValues.totalRemaining) !== 0
    ) {
      setSoldOut(() => {
        return true;
      });
    }
  }, [maxValues.totalRemaining]);

  const setTotalAmountValues = (quantity) => {
    // let price;
    // if (mintSaleType) {
    //   price = 0;
    // }
    setTotalAmount(
      (parseFloat(quantity) * parseFloat(maxValues.price)).toFixed(2)
    );
  };

  const setTotalValues = (response) => {
    if (response !== undefined) {
      setMaxValues(response);
    } else {
      showNotification(
        notificationType.DANGER,
        metamaskErrorMessages.browserNotSupported,
        notificationSetting
      );
      setMaxValues({
        maxMints: 100,
        totalRemaining: 0,
        maxPerMint: 3,
        price: null,
      });
    }
  };

  const manageCounter = (buttonType) => {
    const { min, max, value } = quantityRef.current;
    let newValue = manageCounterProcessing(buttonType, min, value, max);
    setQuantity(newValue);
    setTotalAmountValues(newValue);
  };

  // const getPrivateSaleStatus = async (event) => {
  //   const statusOfPrivateSale = await privateSaleStatus();
  //   console.log("Private Sale Status",statusOfPrivateSale);
  //   if (statusOfPrivateSale?.status) {
  //     setMintSaleType(saleType.PRIVATE_SALE);
  //   }else{
  // showNotification(
  //   notificationType.DANGER,
  //   response.message,
  //   notificationSetting
  // );
  // }
  // };

  const mintNFTPressed = async (event) => {
    event.preventDefault();
    StartLoader(loaderType.BUTTON);
    const { status, message, hash } = await mintNFT(
      quantity,
      totalAmount,
      mintSaleType
    );
    if (status) {
      StopLoader(loaderType.BUTTON);
      let response = await totalValues();
      setTotalValues(response?.total);
      setQuantity(1);
      setTotalAmountValues(1);
      showNotification(notificationType.SUCCESS, message, {
        title: "Minting Successful",
        duration: 6000,
        notificationPosition: notificationPosition.BOTTOM_RIGHT,
      });
    } else {
      StopLoader(loaderType.BUTTON);
      showNotification(notificationType.DANGER, message, notificationSetting);
    }
  };

  return (
    <div className="banner-sec mint-ban">
      <div className="container">
        <h2 className="text-center">Super Creators Assemble</h2>
        <div className="banner-item">
          <div className="item-left">
            <div className="img-art">
              <img src="assets/images/creator-1.png" alt="" />
            </div>
          </div>
          <div className="item-right text-start">
            <div className="title1">
              {maxValues.totalRemaining}/{maxValues.maxMints} Boarded{" "}
            </div>
            <form className="min-form">
              <div className="counter-row">
                <div className="inner-item">
                  <div className="input-counter mb-3">
                    <button
                      type="button"
                      className="minus-btn"
                      id="minus-btn"
                      onClick={() => manageCounter("minus")}
                    >
                      <i className="bi bi-dash"></i>
                    </button>
                    <span>Qty.</span>
                    <input
                      type="text"
                      id="quantity"
                      name="quantity"
                      className="form-control"
                      value={quantity}
                      ref={quantityRef}
                      min={1}
                      max={maxValues.maxPerMint}
                      onChange={() => console.log("")}
                    />
                    <button
                      type="button"
                      className="plus-btn"
                      id="plus-btn"
                      onClick={() => manageCounter("plus")}
                    >
                      <i className="bi bi-plus"></i>
                    </button>
                  </div>
                  <div className="input-form mb-3">
                    <span>Amount (ETH)</span>
                    <input
                      type="text"
                      className="form-control"
                      value={totalAmount}
                      onChange={() => console.log("")}
                      readOnly
                    />
                  </div>
                </div>
                {walletConnected && waiting ? (
                  <button
                    className={"btn btn-dark mt-3"}
                    type={"button"}
                    disabled
                  >
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {"Fetching Data! Please Wait..."}
                  </button>
                ) : (
                  walletConnected &&
                  !soldOut && (
                    <MintButton
                      type={"button"}
                      className={"btn btn-dark mt-3"}
                      onClick={mintNFTPressed}
                    >
                      Mint!
                    </MintButton>
                  )
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mint;
